import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function StartEarning() {
  const { ref, isVisible } = useScrollReveal();

  const steps = [
    {
      number: 1,
      title: "Submit your application",
      description: "Fill out our partnership request and connect with",
    },
    {
      number: 2,
      title: "Contract & Onboarding",
      description: "Review terms, sign contract, and get access to your dashboard",
    },
    {
      number: 3,
      title: "Start Growing",
      description: "Access all tools, support, and revenue opportunities immediately",
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-[#1a1a1a] w-full xxs:px-6 xs:px-8 py-20 lg:py-32`}
    >
      <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 space-y-8 lg:space-y-8">
        <p className="font-medium text-[#757575] text-xs xxs:text-xs xs:text-sm sm:text-sm md:text-md lg:text-lg 4xl:text-[24px] text-center enfinity-subtext-font enfinity-subtext-font">
        How does it work?
        </p>

        {/* Main Heading */}
        <div className="text-center">
          <p className="text-2xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal leading-tight xxs:leading-[1.3] xs:leading-[1.2] sm:leading-[1.15] md:leading-[1.1] lg:leading-tight text-white enfinity-header-font" style={{ lineHeight: "1.1" }}>
            Start earning more in 
            <br />
            <span
              className="bg-gradient-to-r from-[#00d115] via-[#00b0ff] to-[#9c44e9] bg-clip-text text-transparent enfinity-header-font"
              style={{ 
                WebkitTextFillColor: "transparent",
                backgroundImage: "linear-gradient(to right, #00d115 -50%, #00b0ff 100%, #9c44e9 100%)"
              }}
            >
              3 simple steps
            </span>
          </p>
        </div>

        {/* Subtitle */}
        <p className="text-sm xxs:text-[1rem] lg:text-xl xl:text-2xl font-normal leading-relaxed text-center text-white max-w-3xl">
          Join thousands of creators who have transformed their YouTube channels into thriving businesses with Enfinity.
        </p>

        {/* Three Steps */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 md:gap-8 w-full pt-12 xxs:px-4 xs:px-6 sm:px-8 md:px-12 lg:px-20 enfinity-header-font">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col gap-8 items-center text-center flex-1 max-w-sm"
            >
              {/* Numbered Circle */}
              <div className="relative flex items-center justify-center">
                <div
                  className="rounded-full flex items-center justify-center xxs:w-[60px] xxs:h-[60px] xs:w-[65px] xs:h-[65px] sm:w-[68px] sm:h-[68px] md:w-[70px] md:h-[70px]"
                  style={{
                    background: "#292929",
                  }}
                >
                  <p className="xxs:text-[1.125rem] lg:text-4xl font-normal text-white">
                    {step.number}
                  </p>
                </div>
              </div>

              {/* Step Content */}
              <div className="flex flex-col gap-5 items-center text-center text-white w-full">
                <p className="font-normal xxs:text-lg xs:text-lg sm:text-xl md:text-xl lg:text-2xl leading-normal enfinity-subtext-font">
                  {step.title}
                </p>
                <p className="font-normal xxs:text-[1rem] lg:text-[13px] xl:text-lg 4xl:text-[17px] leading-relaxed max-w-55 enfinity-header-font">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
